<template>
  <!-- eslint-disable vue/no-v-model-argument -->
  <div>
    {{ $t('Are you prepared to be taxed as an Employee with Worksome handling the taxes?') }}
    <span class="small c-gray">
      {{
        $t(
          'For some jobs in Worksome, you can only be paid through a payroll (PAYE) even if you have a Limited company.',
        )
      }}
    </span>

    <WdsAlert
      v-if="businessEntityType === 'umbrella'"
      warning
      class="m-t-10"
      description="If you use an Umbrella company as your business entity, then we don't support using PAYE."
    />

    <div class="m-t-20">
      <WdsCheckbox
        v-model:checked="internalModelValue"
        name="business_entity_data[can_paye]"
        :disabled="businessEntityType === 'umbrella'"
        :value="1"
      >
        {{ $t('Yes, I will work with PAYE on some contracts') }}
        <br />
        <span class="c-gray small">
          {{ $t('You will need to supply additional data when you enter a contract.') }}
          <WdsTooltip
            text="With PAYE (Pay As You Earn) Worksome will pay your income tax and
            national insurance contributions. You will be asked to fill out the required
            data for us to complete your payments."
            top
          >
            <a :href="complianceEditUrl">
              {{ $t('Learn more') }}
            </a>
          </WdsTooltip>
        </span>
      </WdsCheckbox>
    </div>
  </div>
</template>

<script>
import { WdsAlert, WdsCheckbox, WdsTooltip } from '@worksome/wds-components'
import { computed } from 'vue'

export default {
  components: {
    WdsAlert,
    WdsCheckbox,
    WdsTooltip,
  },
  props: {
    businessEntity: {
      type: Object,
      required: true,
    },
    modelValue: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const businessEntityType = computed(() => props.businessEntity.entityType)
    const internalModelValue = computed({
      get() {
        return props.modelValue
      },
      set(modelValue) {
        emit('update:modelValue', modelValue)
      },
    })
    return {
      businessEntityType,
      complianceEditUrl: '/compliance/UkPayrollCompliance/edit',
      internalModelValue,
    }
  },
}
</script>
